import script from "./VendorCodeCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./VendorCodeCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./VendorCodeCellElementLite.vue?vue&type=style&index=0&id=3a318a31&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a318a31"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QMenu,QCard,QDialog});
